import { createFileRoute } from '@tanstack/react-router'
import { PepRouteComponent } from '@/components/pep/PepRouteComponent'

export const Route = createFileRoute('/services/pep/')({
	head: () => ({
		meta: [
			{ title: 'Understanding Post-Exposure Prophylaxis (PEP) for HIV | Wellview Care' },
			{
				name: 'description',
				content:
					'Learn about Post-Exposure Prophylaxis (PEP) for HIV at Wellview Care in Fort Lauderdale, Fort Pierce and Riviera Beach. Discover how PEP works, when to consider it, and why our clinic is the trusted choice for rapid response, expert guidance, and confidential care.',
			},
			{
				name: 'keywords',
				content: 'PEP, HIV Prevention, Wellview Care Riviera Beach, Fort Lauderdale, Fort Pierce Healthcare, Florida',
			},
		],
	}),
	component: PepRouteComponent,
})
